<template>
    <div class="loader" v-if="this.$root.getSessaoExpirada()">


        <div class="div-login-expirado">
            <br/>
            <center><b>Sua sessao expirou!<br/>
            Informe os seu dados para <br/>efetuar um novo login:<br/><br/></b></center>
            <form-login :telainicio="false"/>
        </div>
    </div>
</template>



<script>

import FormLogin from '@/components/layout/FormLogin.vue';

export default {
    name : 'LoginExpirado',
    components: {FormLogin}
}
</script>

<style scoped>

	.div-login-expirado{
        display: table;
        background-color: white;
        --border: 1px solid red;
        margin: auto;
        margin-top: 60px ;
        box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
        border-radius: 10px;
    }

</style>